const React = require('react');

const Chevron = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <path fill="#3483FA" fillRule="evenodd" d="M3.79 12L8 7.658 12.21 12l1.29-1.33L8 5l-5.5 5.67z" />
  </svg>
);

module.exports = Chevron;
